// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__37N8f","col":"styles_col__DeZ34"};